import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsbutton-group',
	templateUrl:'./BSButtonGroupPage.html',
	styles: [],
	styleUrls:['./BSButtonGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSButtonGroupPage
{
	mdContent_69 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.groups.BSButtonGroup;
\`\`\``;
	mdContent_70 = `\`\`\`java
new BSButtonGroup<>()
\`\`\``;
	mdContent_71 = `\`\`\`java
var group = new BSButtonGroup<>();
group.add(new BSButtonPrimary<>().setText("Left"));
group.add(new BSButtonPrimary<>().setText("Middle"));
group.add(new BSButtonPrimary<>().setText("Right"));
\`\`\``;
}
